import React from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import InnerHTML from '@Components/InnerHTML';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import SubstancePropertyComponent from '@Components/Results/substances/substance-property.component';

export default class SubstanceReaxysInformation extends React.PureComponent {
  render() {
    const { metadata, substance, details, database, substanceIndex, facts, toggle, zoom } = this.props;
    const { chemicalNames = [] } = details;

    return (
      <>
        <div className="u-els-font-size-h3">
          <InnerHTML tag="span" html={chemicalNames[0]} />
        </div>
        <ul className="rx-accordion medium">
          {map(
            facts,
            (fact, id) =>
              !fact.hitData && (
                <SubstancePropertyComponent
                  key={id}
                  metadata={metadata}
                  substance={substance}
                  fact={fact}
                  details={details}
                  database={database}
                  substanceIndex={substanceIndex}
                  toggle={toggle}
                  open={fact.isOpen}
                  zoom={zoom}
                />
              )
          )}
        </ul>
      </>
    );
  }
}

SubstanceReaxysInformation.propTypes = {
  metadata: MetadataPropTypesShape,
  substance: PropTypes.object.isRequired,
  details: PropTypes.object.isRequired,
  database: PropTypes.object.isRequired,
  substanceIndex: PropTypes.string.isRequired,
  facts: PropTypes.object,
  toggle: PropTypes.func,
  zoom: PropTypes.number,
};
